import { HttpErrorResponse } from '@angular/common/http';

export enum ERROR_TYPE {
  SERVER_MESSAGE = 'SERVER_MESSAGE',
  UNAUTHORIZED = 'UNAUTHORIZED',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  NETWORK_ERROR = 'NETWORK_ERROR',
}

export interface ExtractedError {
  type: ERROR_TYPE;
  message?: string;
}

const CAPTCHA_INVALID_MESSAGE = 'Captcha is not valid';

export function extractErrorMessage(response: HttpErrorResponse): ExtractedError {
  if (response.status === 0) {
    return { type: ERROR_TYPE.NETWORK_ERROR };
  }

  if (response.status === 401) {
    if (response.error?.message === CAPTCHA_INVALID_MESSAGE) {
      return { type: ERROR_TYPE.SERVER_MESSAGE, message: response.error.message };
    }

    return { type: ERROR_TYPE.UNAUTHORIZED };
  }

  if (response.status >= 400 && response.status < 500) {
    return { type: ERROR_TYPE.SERVER_MESSAGE, message: response?.error?.message };
  }

  return { type: ERROR_TYPE.INTERNAL_SERVER_ERROR };
}

export function toErrorTranslationKey(response: HttpErrorResponse): string | undefined {
  const error = extractErrorMessage(response);

  return error.type === ERROR_TYPE.SERVER_MESSAGE
    ? error.message
    : `LOGIN_PAGE.ERROR.${error.type}`;
}
